import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white">
            <h5 className="text-white">
              <br />
              <br />
            </h5>
          </Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Banque Misr has undergone significant digital transformation under your
                leadership, with remarkable growth in digital banking services. What were the key
                success factors behind this transformation, and how did you align technology with
                customer needs?
              </strong>
            </h5>

            <h5 className="text-white">
              <b>We placed our customers at the heart</b> of our transformation strategy. By
              actively listening to their needs and preferences, we were able to design digital
              solutions that offers best customer experience, digital banking experience, empowered
              with latest technology enables like bio-metric authentication, Facial recognition,
              Apple Pay. <br />
              <br />
              We <b>invested in advanced digital platforms</b>, and Data-driven solutions to enhance
              the customer experience. This allowed us to offer seamless, secure, and personalized
              banking services.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- Banque Misr has emerged as a market leader in digital payments in Egypt.What are
                the biggest drivers behind this growth, and how do you see the future of digital
                payments evolving in Egypt and the region?
              </strong>
            </h5>
            <h5 className="text-white">
              The bank's emergence as a market leader in digital payments in Egypt can be attributed
              to several key drivers:
              <br />
              <br />
              1. Government Initiatives and Regulatory Support: The Egyptian government has been
              proactive in promoting digital payments through various initiatives and regulatory
              frameworks. The Central Bank of Egypt's introduction of the Instant Payment Network
              (IPN) and the easing of KYC requirements have significantly boosted digital payment
              adoption
              <br />
              2. Increasing Mobile and Internet Penetration: Egypt has seen a substantial rise in
              smartphone and internet usage, making digital payments more accessible to a larger
              population.
              <br />
              3. Consumer Demand for Convenience: The shift towards digital payments has been driven
              by consumer demand for more convenient, secure, and efficient payment methods. The
              ability to make instant payments and transfers has resonated well with the tech-savvy
              population.
              <br />
              4. Collaborations with FinTechs: Partnerships with local and international FinTech
              companies have enabled the bank to address wide spectrum of customer needs effectively
              <br />
              <br />
              Looking ahead, the future of digital payments in Egypt and the region is promising:
              <br />
              <br />• <b>Continued Growth and Innovation:</b> We can expect continued growth in
              digital payments, driven by ongoing technological advancements and increasing consumer
              adoption. Innovations such as biometric authentication and blockchain technology will
              further enhance security and efficiency.
              <br />
              <b>• Emended finance:</b> Digital payments will pave the way for the expansion of
              other financial services, including digital lending, insurance, and investment
              platforms. This will create a more comprehensive digital financial ecosystem.
              <br />
              <b>• Regional Integration:</b> The Middle East and North Africa (MENA) region will see
              greater integration of digital payment systems, facilitating cross-border transactions
              and boosting regional trade.
              <br />
              <b>• Regulatory Evolution: </b>Regulatory frameworks will evolve to support innovation
              while ensuring security and consumer protection. This will create a conducive
              environment for the growth of digital payments.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- Fintech collaborations are reshaping the financial services landscape.How does
                Banque Misr approach partnerships with fintech startups and technology providers to
                drive innovation and enhance customer experience?
              </strong>
            </h5>
            <h5 className="text-white">
              Banque Misr has adopted a strategic and collaborative approach to partnerships with
              fintech startups and technology providers to drive innovation and enhance customer
              experience:
              <br />
              <br />
              1. Digital payments Fintech’s collaborations: the bank has been leading the market in
              digital payments acceptance with Fintechs either start-ups, technology providers or
              ecosystem orchestrators, As well as the largest payment cards partnerships portfolio
              that enables payments fintech players to introduce market innovation and address
              customer needs effectively.
              <br />
              2. Open Innovation Programs: Banque Misr has launched initiatives like the Open
              Innovation Program in collaboration with Microsoft. This program supports fintech
              startups by providing them with resources, mentorship, and access to advanced
              technologies. It fosters extensive integration between the bank and fintech startups,
              enabling co-creation of innovative solutions.
              <br />
              3. Support for Entrepreneurs: Banque Misr is committed to supporting entrepreneurs and
              startups in the fintech sector. Through various programs and partnerships, the bank
              provides startups with the resources and guidance needed to succeed. This support
              helps drive innovation and contributes to the growth of the fintech ecosystem in
              Egypt.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Sustainability has become an essential pillar in the banking sector. How is Banque
                Misr integrating sustainable banking practices into its digital transformation
                strategy?
              </strong>
            </h5>
            <h5 className="text-white">
              1. Digital Transformation and Green Technology: The bank leverages digital platforms
              to enhance sustainability efforts. For example, we have implemented digital receipts
              and estatements, significantly reducing paper usage and improving energy
              efficiency[1]. Additionally, our mobile banking app offers features like electronic
              bill payments and digital account management, further minimizing our environmental
              footprint.
              <br />
              <br />
              2. Responsible Banking Practices: Banque Misr has signed the United Nations Principles
              of Responsible Banking, committing to align its business strategy with the SDGs and
              the Paris Agreement on climate change. This ensures that sustainability is embedded in
              the bank's core values and decision-making processes. We also promote the use of
              digital wallets and contactless payments, reducing the need for physical cash and
              contributing to a cashless, eco-friendly economy.
              <br />
              <br />
              3. Commitment to ESG Principles: Banque Misr is dedicated to Environmental, Social,
              and Governance (ESG) principles, aligning its financial products and services with the
              United Nations Sustainable Development Goals (SDGs). This includes financing green
              projects and sustainable businesses to promote environmental protection and social
              inclusion
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- Leading transformation in one of Egypt’s largest banks requires both vision and
                leadership.What leadership principles have guided you throughout your career,
                especially during times of digital disruption?
              </strong>
            </h5>
            <h5 className="text-white">
              Leading transformation in one of Egypt’s largest banks indeed requires both vision and
              leadership. Throughout my career, especially during times of digital disruption,
              several key leadership principles have guided me:
              <br />
              <br />
              1. The power of People: Fostering a culture of collaboration within the organization
              is vital. By encouraging cross-functional teams to work together, we were able to
              drive innovation and ensure that our digital initiatives were aligned with our overall
              business goals. Partnerships with fintech startups and technology providers and such
              talented individuals and seeing their ideas come to life has been one of the most
              fulfilling and joyful aspects of my role.
              <br />
              <br />
              2. Visionary Thinking: Having a clear and compelling vision is essential. This
              involves anticipating future trends and setting ambitious goals that inspire and
              motivate the entire organization.
              <br />
              <br />
              3. Agility and Adaptability: In times of digital disruption, being agile and adaptable
              is crucial. This means being open to change, embracing emerging technologies, and
              quickly responding to market shifts. Implementing agile methodologies allowed us to
              continuously improve our digital offerings and stay ahead of the curve. It's about
              being ready to pivot when necessary and always keeping the customer at the forefront
              of our decisions.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- Looking ahead, what are your top priorities for driving Banque Misr’s digital
                banking and payments strategy in the next 3-5 years?What innovations or technologies
                do you believe will shape the future of banking in Egypt?
              </strong>
            </h5>
            <h5 className="text-white">
              our top priorities for driving Banque Misr’s digital banking and payments strategy in
              the next 3-5 years include:
              <br />
              <br />
              1. Hyper Personalization “Segment of a One” : Our primary focus is on delivering a
              seamless and personalized customer experience. This involves leveraging data analytics
              and AI to understand customer preferences and offer tailored solutions. We aim to
              expand our digital services convenience to offer our customers what they really need.
              <br />
              <br />
              2. Promoting Financial Inclusion: We are committed to increasing financial inclusion
              by providing digital banking solutions to underserved and unbanked populations. This
              includes expanding our digital payment services and collaborating with fintech
              startups to develop innovative products that cater to diverse customer needs.
              <br />
              <br />
              3. Investing in Advanced Technologies: To stay ahead in the rapidly evolving financial
              landscape, we will continue to invest in cutting-edge technologies such as blockchain,
              AI, and open banking. These technologies will enhance security, improve operational
              efficiency, and enable us to offer innovative financial products and services.
              <br />
              <br />
              As for the innovations and technologies that will shape the future of banking in
              Egypt, we believe the following will be pivotal:
              <br />
              <br />
              • Open Banking & Imbedded Finance: Open banking will facilitate greater collaboration
              between traditional banks and fintech companies. By allowing third-party providers to
              access customer data (with consent), open banking will enable the creation of
              innovative financial solutions that offer whole new level of customer experience.
              <br />
              <br />
              • Mobile Payments and Digital Wallets: The rise of mobile payments and digital wallets
              has no end, with everyday development we keep will driving the shift towards a
              cashless economy.
              <br />
              <br />• Artificial Intelligence (AI): AI will continue to revolutionize the banking
              sector by automating tasks such as fraud detection, customer service, and personalized
              financial advice. AI-powered chatbots and virtual assistants will enhance customer
              interactions and provide real-time support.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- With the increasing adoption of contactless payments, mobile wallets, and instant
                payments, how do you see the digital payments ecosystem in Egypt evolving, and what
                role will Banque Misr play in shaping its future?
              </strong>
            </h5>
            <h5 className="text-white">
              Banque Misr plays a pivotal role in shaping this transformation through four key
              strategies:
              <br />
              <br />
              1. Always Support Modern Practices: Banque Misr is committed to the pioneer for
              applying modern practices to enhance the digital payments experience. This includes
              leveraging tokenization to ensure secure transactions, adopting instant payment
              networks for efficient fund transfers, and promoting the use of mobile payments and
              digital wallets.
              <br />
              <br />
              2. Invest in Enabling Technologies: Banque Misr continuously invests in cutting-edge
              technologies to drive innovation and improve operational efficiency. This includes
              digital payments platforms, Data & AI for personalized customer interactions, and open
              banking to foster collaboration with fintech startups. By investing in these
              technologies, the bank ensures that its digital payment solutions remain at the
              forefront of the industry.
              <br />
              <br />
              3. Secure and Compliant Implementation: Ensuring secure and compliant implementation
              of digital payment solutions is a top priority for Banque Misr. The bank adopts robust
              security measures, such as tokenization, to protect customer data during transactions.
              Compliance with regulatory standards and best practices ensures that all digital
              payment services are safe, reliable, and trustworthy.
              <br />
              <br />
              4. Enable Partners and Fintechs to Apply Modern Practices: Banque Misr actively
              collaborates with fintech startups and technology providers to drive innovation in
              digital payments, these collaborations empower fintechs to apply modern practices and
              develop
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-As the banking industry continues to undergo rapid digital transformation, what is
                your personal vision for the future of banking in Egypt, and what legacy would you
                like to leave behind in shaping the country's digital financial ecosystem?
              </strong>
            </h5>
            <h5 className="text-white">
              My vision for the future of banking in Egypt that we will whiteness a new way of how
              our financial needs being served, the banking services will be more personalized and
              integrated in our day to day interactions seamlessly, and this will not be exclusive
              to specific segments.
              <br />
              <br />
              And I’m looking forward to engrave key values of empowering people and make life
              easier for the mass population, challenge each change and embrace the iterative
              learning & finally
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
